import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { SkincareAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-skincare-slot',
    templateUrl: './skincare-slot.component.html',
    styleUrl: './skincare-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkincareSlotComponent implements SheetSlotComponentBase {

	@Input() action!: SkincareAction;
	value = null;

	constructor() {
	}
}